'use strict';

module.exports = require('./dissocPath').dissocPath;



//////////////////
// WEBPACK FOOTER
// ./~/ramda.dissocpath/index.js
// module id = 1598
// module chunks = 2